import React, { useState } from 'react'
import { View, StyleSheet, FlatList } from 'react-native'
import PropTypes from 'prop-types'
import SkeletonContent from 'react-native-skeleton-content'
import { useNavigation } from '@react-navigation/native'

import Txt from '../../../../components/Txt'
import LaneCard from '../LaneCard'
import IconButton from '../../../../components/IconButton'
import AddLaneModal from '../../../../components/AddLaneModal'
import { usePlatforms } from '../../../../hooks/usePlatforms'

const PreferredLanes = ({ lanes, loading }) => {
  const navigation = useNavigation()
  const { isTablet } = usePlatforms()
  const [openAddLaneModal, setOpenAddLaneModal] = useState(false)

  const onGoToPreferredLanes = () => {
    navigation.navigate('preferred-lanes')
  }

  const skeleton = {
    container: {
      flex: 1,
      flexDirection: 'row'
    },
    card: {
      width: isTablet ? 210 : 180,
      height: 86,
      margin: 10
    }
  }

  return (
    <>
      <View style={styles.container}>
        <Txt
          Key='dashboardPrederredLanesTitle'
          text='Preferred Lanes'
          identity='body1Bold'
          style={styles.title}
          color='OUTER_SPACE'
        />
        <View
          style={[
            styles.lanesCardsContainer
          ]}
        >
          <SkeletonContent
            containerStyle={skeleton.container}
            isLoading={loading}
            layout={[
              skeleton.card,
              skeleton.card,
              skeleton.card
            ]}
          >
            {lanes.length ? (
              <FlatList
                horizontal
                showsHorizontalScrollIndicator={false}
                data={lanes}
                renderItem={({ item, index }) => (
                  <LaneCard
                    lane={item}
                    onPress={onGoToPreferredLanes}
                    index={index}
                  />
                )}
                keyExtractor={(_, key) => key.toString()}
                testID='dashboardPreferredLanesList'
                accessibilityLabel='dashboardPreferredLanesList'
              />
            ) : (
              <Txt
                Key='noPrederredLanesMessage'
                text='No preferred lanes found'
                identity='subtitle'
                style={{ paddingVertical: 40 }}
                color='OUTER_SPACE'
              />)}
          </SkeletonContent>
        </View>
        <View style={styles.addButtonContainet}>
          <IconButton
            color='AZTEC'
            icon='Plus'
            onPress={() => setOpenAddLaneModal(true)}
          />
        </View>
      </View>
      <AddLaneModal
        open={openAddLaneModal}
        onClose={() => setOpenAddLaneModal(false)}
      />
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    zIndex: 2,
    position: 'relative',
    marginBottom: 20
  },
  title: {
    fontWeight: 'normal'
  },
  lanesCardsContainer: {
    marginVertical: 10
  },
  addButtonContainet: {
    position: 'absolute',
    bottom: 0
  }
})

PreferredLanes.propTypes = {
  lanes: PropTypes.array.isRequired,
  loading: PropTypes.bool
}

PreferredLanes.defaultProps = {
  lanes: [],
  loading: false
}

export default PreferredLanes
